import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=ec24feda&"
import script from "./AboutView.vue?vue&type=script&lang=js&"
export * from "./AboutView.vue?vue&type=script&lang=js&"
import style0 from "./AboutView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports